import { postPrePrimeRefferal } from '~/services/preprime-api';
import TrackDataHelper from '~/helpers/track-data-helper';
import AnalyticsHelper from '~/helpers/analytics';
import appStorage from '~/helpers/app-storage';
import trackData from './track-data';

export default {
    props: {
        lenderName: {
            default: '',
        },
        apr: {
            default: 0,
        },
        contactNumber: {
            default: 0,
        },
        offerId: {
            default: '',
        },
        lenderId: {
            default: '',
        },
        quotesId: {
            default: '',
        },
        loanAmount: {
            default: '',
        },
        lendingEntityId: {
            type: Number,
        },
        variationName: {
            default: '',
        },
        firstName: {
            default: '',
        },
        lastName: {
            default: '',
        },
        email: {
            default: '',
        },
        phone: {
            default: '',
        },
    },
    data() {
        return {
            FirstName: this.firstName,
            LastName: this.lastName,
            Email: this.email,
            Phone: this.phone,
            LeadGuid: null,
            LendingEntityId: this.lendingEntityId,
            IsPhoneValid: true,
            IsEmailValid: true,
            IsButtonDisabled: true,
        };
    },
    methods: {
        loanPurpose() {
            const loanPurpose = parseInt(trackData.get().loantype || trackData.get().loanpurpose, 10) === 1 ? 'Purchase' : 'Refinance';
            return loanPurpose;
        },
        submitLeadDetails() {
            this.submitPrePrimeReferel();
            this.successCallback();
        },
        successCallback() {
            // TODO:: Show alert message of successful lead submission
        },
        submitPrePrimeReferel() {
            const storageKey = this.vertical === 'credit repair' ? 'credit-repair-lead' : 'debt-relief-lead';
            const leadSessionId = appStorage.get(storageKey);
            const data = {
                FirstName: this.FirstName,
                LastName: this.LastName,
                PhoneNumber: this.Phone,
                EmailAddress: this.Email,
                FormId: leadSessionId != null ? leadSessionId.LeadGuid : null,
                LendingEntityId: this.LendingEntityId,
                ScheduleType: 'Now',
                variationName: this.variationName,
            };
            if (leadSessionId != null) {
                TrackDataHelper.setMany(this.partnerCTACheckout(leadSessionId.LeadGuid), 'LeadContactform');
                AnalyticsHelper.track('Checkout Started', TrackDataHelper.get('LeadContactform'));
                postPrePrimeRefferal(data, 'schedule');
            } else if (WP_LT_ENV !== 'prod') {
                console.warn('partnerCTACheckout failed because leadSessionId is null');
            }
        },
    },
    mixins: [trackData],
};
